import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import AdminLayout from './components/layout/AdminLayout';
import DashboardPage from './pages/DashboardPage';
import CallLogPage from './pages/CallLogPage';
import StatsPage from './pages/StatsPage';
import OperatorsPage from './pages/OperatorsPage';
import SettingsPage from './pages/SettingsPage';
import ContactsPage from './pages/ContactsPage';
import ProductivityPage from './pages/ProductivityPage';
import OperatorStatsPage from './pages/OperatorStatsPage';
import ForwardingPage from './pages/ForwardingPage';
import DealsPage from './pages/DealsPage';
import TasksPage from './pages/TasksPage';
import ContactDetailPage from './pages/ContactDetailPage';
import DispositionsPage from './pages/DispositionsPage';
import KnowledgePage from './pages/KnowledgePage';
import NoteAnalyticsPage from './pages/NoteAnalyticsPage';
// Yangi operator paneli — alohida `/op` manzilida, eski panelga tegmaydi.
import Operator2Layout from './pages/operator2/Operator2Layout';
import WorkspacePage from './pages/operator2/WorkspacePage';

function PrivateRoute({ children, role, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-center"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  // `roles` — bir nechta rolga ruxsat (yangi panelni admin ham ko'ra oladi).
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to={user.role === 'admin' ? '/admin' : '/operator'} replace />;
  }
  return children;
}

// Operator panelining bo'limlari — `/operator` va `/op` uchun bir xil.
const operatorRoutes = () => ([
  <Route key="index" index element={<WorkspacePage />} />,
  <Route key="contacts" path="contacts" element={<ContactsPage />} />,
  <Route key="contact" path="contacts/:id" element={<ContactDetailPage />} />,
  <Route key="tasks" path="tasks" element={<TasksPage />} />,
  <Route key="deals" path="deals" element={<DealsPage />} />,
  <Route key="knowledge" path="knowledge" element={<KnowledgePage />} />,
  <Route key="productivity" path="productivity" element={<ProductivityPage />} />,
  <Route key="stats" path="stats" element={<OperatorStatsPage />} />,
]);

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-center"><div className="spinner" /></div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/operator'} replace /> : <LoginPage />} />
      
      <Route path="/admin" element={<PrivateRoute role="admin"><AdminLayout /></PrivateRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="calls" element={<CallLogPage />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="note-analytics" element={<NoteAnalyticsPage />} />
        <Route path="operators" element={<OperatorsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="contacts/:id" element={<ContactDetailPage />} />
        <Route path="deals" element={<DealsPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="dispositions" element={<DispositionsPage />} />
        <Route path="knowledge" element={<KnowledgePage />} />
        <Route path="productivity" element={<ProductivityPage />} />
        <Route path="forwarding" element={<ForwardingPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      
      {/* OPERATOR PANELI (`pages/operator2`). Eski panel va `/op` taqlid manzili
          2026-10-26 da olib tashlandi — endi yagona manzil `/operator`. */}
      <Route path="/operator" element={<PrivateRoute roles={['operator', 'admin']}><Operator2Layout /></PrivateRoute>}>
        {operatorRoutes()}
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{
          style: { background: '#1e293b', color: '#f1f5f9', border: '1px solid #2d3a4f', borderRadius: '10px' },
        }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
